import { useCallback, useState } from "react";
import Tab from './Tab';

export default function TabBar(props){
  const tabs = props.tabs;
  const selected = props.selected;
  const lgWidth = 1200/tabs.length;

  // 모바일 한정
  const [showAll, setShowAll] = useState(false);

  const handleSelect = useCallback((index)=>{
    setShowAll(false);
    props.callback(index)
  },[props]);

  const handleShowAll = useCallback(()=>{setShowAll(true)}, [setShowAll])

  return (
    <div className={`${props.className} flex flex-col lg:flex-row w-full lg:w-[1200px]`}>
      {tabs.map((tab, index)=>{
        return (
          <Tab key={index} tab={tab} 
              selectCallback={()=>handleSelect(index)}
              showAllCallback={()=>handleShowAll()}
              showAll={showAll}
              index={index}
              selected={index===selected}
              className={`grow lg:w-[${lgWidth}]`}/>
        );
      })}
    </div>
  );
}